module.exports = __webpack_public_path__ + "static/39-techbiollionare-march2017-ccfccc4addd8a6985db544e62fc8b11d.jpg";